module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/model_railroad/icon_cdb4274a194a822d5e852dd3fb4349ff.png";